import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromStaff from './staff/staff.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('staff', fromStaff.reducer)],
})
export class SharedStaffDataAccessModule {}
